(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-mobile-dropdown"] && !Shopify.designMode) return;
  try {
    class HeaderMobileDropdown extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.hmd-trigger');
    this.content = this.querySelector('.hmd-content');
    this.isOpen = false;
    
    if (this.trigger && this.content) {
      this.trigger.addEventListener('click', this.toggle.bind(this));
      
      // 外側クリックで閉じる
      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.contains(e.target)) {
          this.close();
        }
      });
    }
  }
  
  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
  
  open() {
    this.isOpen = true;
    this.classList.add('is-open');
    this.content.style.maxHeight = this.content.scrollHeight + 'px';
  }
  
  close() {
    this.isOpen = false;
    this.classList.remove('is-open');
    this.content.style.maxHeight = '0';
  }
}

customElements.define('header-mobile-dropdown', HeaderMobileDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["coordinate-items"] && !Shopify.designMode) return;
  try {
    class CoordinateItems extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-coordinate-toggle]');
        if (!toggle || !this.contains(toggle)) return;

        const row = toggle.closest('[data-coordinate-row]');
        const panel = row && row.querySelector('.coordinate-items__panel');
        if (!panel) return;

        const willOpen = panel.hasAttribute('hidden');

        // 同じブロック内の他の行は閉じる
        this.querySelectorAll('.coordinate-items__panel').forEach((el) => {
          el.setAttribute('hidden', '');
        });
        this.querySelectorAll('[data-coordinate-toggle]').forEach((el) => {
          el.setAttribute('aria-expanded', 'false');
        });

        if (willOpen) {
          panel.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    }
  }

  if (!customElements.get('coordinate-items')) {
    customElements.define('coordinate-items', CoordinateItems);
  }
  } catch(e) { console.error(e); }
})();

})();
